<div class="tile-container" [class.selected]="element.checkedSw">
  <checkbox-wrap class="checkbox">
    <input type="checkbox" [(ngModel)]="element.checkedSw" />
  </checkbox-wrap>

  <div class="id">
    {{ "translate.general.id" | translate }}: {{ element.annIdPrefix
    }}{{ element.elementId }}

    <span *ngIf="displayPageNum"> | </span>
    <span *ngIf="displayPageNum && element.pageNum == curPage">
      {{ "translate.general.page" | translate }}: {{ element.pageNum }}</span
    >

    <a
      *ngIf="displayPageNum && element.pageNum != curPage"
      (click)="goToPage()"
    >
      {{ "translate.general.page" | translate }}: {{ element.pageNum }}</a
    >
    <reeval-status-icon [target]="reevalTarget" (refresh)="onReevalRefresh()"></reeval-status-icon>
  </div>

  <div *ngIf="phrase" class="phrase">
    <p class="t-footnote">
      {{ phrase.phraseContentTypeDesc }}
    </p>
    <formatted-phrase [phraseWords]="phrase.phraseWords"></formatted-phrase>
  </div>

  <div *ngIf="indImage" class="phrase">
    <p class="t-footnote figure-type">
      {{ indImage.figureTypeDescr }}
      <span *ngIf="indImage.figureSubType"
        >&middot; {{ indImage.figureSubType.text }}</span
      >
    </p>
    <async-img [className]="'ind-img'" [url]="indImage.imgUrl"></async-img>
  </div>

  <div *ngIf="showMatchSw" class="match-type">
    <button *ngIf="phrase" [ngClass]="['match-type-descr', phrase.phraseSimilarityEvent || element.similarityCode || '']" (click)="openPhraseDetails($event)">
      {{ phrase.phraseSimilarityEventDesc || element.similarityDescr }}
    </button>
    <button *ngIf="indImage" [ngClass]="['match-type-descr', indImage.imageSimilarityEvent || element.similarityCode]" (click)="openPhraseDetails($event)">
      {{ indImage.imageSimilarityEventDesc || element.similarityDescr }}
    </button>
    <div class="tile-icon-indicators">
      <!--
      <i *ngIf="!!libraryMismatch" class="task"  tooltip="{{ libraryMismatch[1] | translate }}" tooltipPosition="bottom"></i>
      -->
      <i *ngIf="!!referenceIssues" class="rule" tooltip="{{ referenceIssues[1] }}" tooltipPosition="bottom"></i>
      <i *ngIf="!!contentPartMismatch" class="warning" tooltip="{{ contentPartMismatch[1] }}" tooltipPosition="bottom"></i>
      <i *ngIf="!!spellingGrammarIssues" class="spellcheck" tooltip="{{ spellingGrammarIssues[1] }}" tooltipPosition="bottom"></i>  
      <i *ngIf="!!formatMismatch" class="format" tooltip="{{ formatMismatch[1]
      }}" tooltipPosition="bottom"></i>
      <i *ngIf="!!consistencyIssues" class="priority-high" tooltip="{{ consistencyIssues[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!fairBalanceIssues" class="balance" tooltip="{{ fairBalanceIssues[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!complianceIssues" class="policy-alert" tooltip="{{ complianceIssues[1] }}"
        tooltipPosition="bottom"></i>
    </div>
  </div>

  <p
    *ngIf="element.statusCode && showMatchSw"
    [ngClass]="['cat-phrase-status', element.statusCode]"
  >
    {{ element.statusDescr }}
  </p>
  <spinner
    *ngIf="!element.statusCode"
    class="cat-phrase-status-spinner"
  ></spinner>



  <!--ext ref-->
  <div *ngIf="phrase && phrase.extRefs.length > 0" class="ext-ref">
    <p class="title">{{ "translate.cat.extRefs" | translate }}:</p>
    <div *ngFor="let ref of phrase.extRefs">
      <div class="ref-container">
        <formatted-phrase
          class="text"
          [phraseWords]="ref.extPhraseDispWords"
        ></formatted-phrase>
      </div>

      <p class="footnote l-ta-end">
        {{ ref.extDocName }} ({{ ref.extCatDescr }})
      </p>
    </div>
  </div>

  <!-- instructions -->
  <div
    *ngIf="element.addInstr && element.addInstr.length > 0"
    class="instructions"
  >
    <p class="title">{{ "translate.rev.instructions" | translate }}:</p>

    <cat-add-instr
      *ngFor="let instr of element.addInstr"
      [instr]="instr"
      [editable]="false"
    ></cat-add-instr>
  </div>

  <div *ngIf="editable" class="btn">
    <p-selectButton
      [disabled]="element.parentPhraseId != null && !element.isParentActionSelected"
      class="cat-phrase-status"
      [options]="phraseStatusOptions"
      [(ngModel)]="element.userStatus"
      (onChange)="onPhraseStatusChange()"
    ></p-selectButton>
  </div>

  <div class="icons">
    <!-- Removed dialog for edit phrase
    <i
      *ngIf="editable"
      class="fas fa-edit"
      (click)="editPhrase()"
      tooltip="{{ 'translate.general.edit' | translate }}"
    ></i>
    &nbsp; &nbsp;
    -->
    <!-- Removed Add external reference
    <i
      *ngIf="editable"
      class="far fa-bookmark"
      (click)="onAddExtRef()"
      tooltip="{{ 'translate.cat.addExtRef' | translate }}"
    ></i>
  -->
    &nbsp; &nbsp;
    <div>
      <i
      style="margin-right: 10px"
      *ngIf="editable && isPhrase"
      class="fas fa-file-invoice icon"
      (click)="showClaimTool()"
      tooltip="{{ claimToolLabel | translate }}"
    ></i>
    </div>
    <i
      *ngIf="element.pageNum == curPage && !element.bgImgSw"
      class="fas fa-eye icon-view"
      [class.selected]="element.viewSw"
      (click)="togglePhraseView($event)"
      tooltip="{{ 'translate.general.toggle' | translate }}"
    ></i>
  </div>

  <div class="cat-phrase-type">
    {{ element.typeDescr }}
    <span class="sub-type" *ngIf="element && element.subTypeDescr != null">&middot; {{ element.subTypeDescr }}</span>
  </div>
  <div class="image-categories">
    <span *ngIf="indImage && indImage.figureCategory" class="cat-phrase-type">
      {{ indImage.figureCategory }}
    </span>
    <!--
    <ng-template #noCategory>
      <span class="no-category">{{ "translate.general.no-category" | translate }}</span>
    </ng-template>
    -->
  </div>
</div>

<cat-doc-phrase-details
  *ngIf="phraseDetailsOpenSw"
  (onClose)="phraseDetailsOpenSw = false"
  (onStatusChange)="onPhraseStatusChange()"
  [editModeSw]="phraseEditModeSw"
  (setDisplayDetailsDialogActionsFlag)="checkIfElementHasSelectedUserStatus($event)"
  [editable]="editable"
  [mode]="'ind'"
  (onDelete)="onPhraseDelete()"
  [stateTag]="stateTag"
  [hasNext]="hasNext"
  [hasPrev]="hasPrev"
  (showClaimToolEmitter)="showClaimTool(false)"
  (showNextIndElementEmitter)="showNextIndElement($event)"
  (showPrevIndElementEmitter)="showPrevIndElement($event)"
  (onUpdateSpellingIssues)="notifySpellingIssuesUpdate()"
  (hideAnnotation)="hideAnnotation()"
  [referenceDocuments]="referenceDocuments"
  [claimToolElement]="claimToolElement"
></cat-doc-phrase-details>

<claim-tool *ngIf="showClaimToolDialog"  (showDetailsDialogEmitter)="showDetailsDialog($event)"
 (onClose)="showClaimToolDialog = false" [claim]="claimToolElement"></claim-tool>

<add-ext-ref
  *ngIf="addExtRefOpenSw"
  (onClose)="onAddExtRefClose($event)"
  [srcPhraseId]="phrase ? phrase.phraseId : null"
>
</add-ext-ref>

  <ng-container *ngIf="phrase && phrase.associatedText.length > 0 && phrase.showAssociatedTextSection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.general.associatedText' | translate) + ' (' + phrase.associatedText.length + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div class="associatedText">
          <ng-container *ngFor="let assocPhrase of phrase.associatedText">
            <ng-container *ngIf="assocPhrase.showInTile">
              <div class="ref-container">
                <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
                  {{ assocPhrase.assocPhraseText }}
                </p>
                <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" class="text"
                  [phraseWords]="assocPhrase.phraseDispWords"></formatted-phrase>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="phrase && phrase.showFootnotesSection">
    <div style="margin-left: 20px">

      <p-panel  [header]="('translate.rev.footnotes' | translate) + ' (' + phrase.numberOfFootnotes + ')'"
        [toggleable]="true"
        [collapsed]="true"
        [style]="{position: 'relative', top: '-1.5em'}"
        >
        <ng-container *ngFor="let footnote of phrase.referencesInFootnotesSection">
          <div class="reference">
            <div class="ref-container ref-with-view">
              <p *ngIf="footnote.phraseDispWords.length == 0" class="text">
                {{ footnote.refPhraseText }}
              </p>
              <formatted-phrase *ngIf="footnote.phraseDispWords.length > 0" class="text"
                [phraseWords]="footnote.phraseDispWords"></formatted-phrase>

              <div class="ref-view-action" *ngIf="canViewRefDoc(footnote)">
                <i
                  style="cursor: pointer; color: #0978a2"
                  class="icon fa-solid fa-arrow-up-right-from-square"
                  [class.selected]="true"
                  [tooltip]="'translate.general.viewRefDoc' | translate"
                  (click)="viewRefDoc(footnote)">
                </i>
            </div>
          </div>
          </div>
          </ng-container>
          <ng-container *ngTemplateOutlet="footnotesTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="phrase && phrase.numberOfContextCatPhrases > 0 && phrase.showReferencesSection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.rev.reference' | translate) + ' (' + phrase.numberOfContextCatPhrases + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div class="reference">
          <ng-container *ngFor="let ref of phrase.references">
            <ng-container *ngIf="ref.showInTile">
              <div class="ref-container ref-with-view" [ngClass]="ref.isConsistencyGenerated ? 'border-indicator-anchor' : 'border-indicator-reference'">
                <p *ngIf="ref.phraseDispWords.length == 0" class="text">
                  {{ ref.refPhraseText }}
                </p>
                <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
                  [phraseWords]="ref.phraseDispWords"></formatted-phrase>

                <div class="ref-view-action" *ngIf="canViewRefDoc(ref)">
                  <i
                    style="cursor: pointer; color: #0978a2"
                    class="icon fa-solid fa-arrow-up-right-from-square"
                    [class.selected]="true"
                    [tooltip]="'translate.general.viewRefDoc' | translate"
                    (click)="viewRefDoc(ref)">
                  </i>
                </div>

                <ng-container *ngIf="ref.anchors != null">
                  <mng-anchors
                    [anchors]="ref.anchors"
                    [phrase]="phrase"
                    [simpleView]="true"
                  ></mng-anchors>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </p-panel>
    </div>
  </ng-container>

  <ng-container *ngIf="element && element.numberOfAssociatedBy > 0 && element.showAssociatedBySection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.general.associatedBy' | translate) + ' (' + element.numberOfAssociatedBy + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div class="associatedBy">
          <ng-container *ngFor="let assocPhrase of element.associatedBy">
            <ng-container *ngIf="assocPhrase.showInTile">
              <div class="ref-container">
                <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
                  {{ assocPhrase.assocPhraseText }}
                </p>
                <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" class="text"
                  [phraseWords]="assocPhrase.phraseDispWords"></formatted-phrase>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </p-panel>
    </div>
  </ng-container>

  <ng-container *ngIf="phrase && phrase.numberOfReferencedBy > 0 && phrase.showReferencedBySection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.rev.referencedBy' | translate) + ' (' + phrase.numberOfReferencedBy + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div class="referencedBy">
          <ng-container *ngFor="let ref of phrase.referencedBy">
            <ng-container *ngIf="ref.showInTile">
              <div class="ref-container">
                <p *ngIf="ref.phraseDispWords.length == 0" class="text">
                  {{ ref.refPhraseText }}
                </p>
                <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
                  [phraseWords]="ref.phraseDispWords"></formatted-phrase>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </p-panel>
    </div>
  </ng-container>

  <ng-container *ngIf="phrase && phrase.showTablesSection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.general.tables' | translate) + ' (' + phrase.numberOfTables + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div *ngIf="phrase.showAssociatedTablesSection" class="associatedImages">
          <ng-container *ngFor="let img of phrase.associatedImages">
            <ng-container *ngIf="img.showInTile && img.type == 'TABLE'">
              <div style="margin-bottom: 0.5em;">
                <p class="t-footnote figure-type">
                  ID: {{ img.assocImageId }}
                </p>
                <async-img [className]="'ind-img'" [url]="img.imgUrl"></async-img>
              </div>
            </ng-container>
  
          </ng-container>
        </div>
          <ng-container *ngTemplateOutlet="tablesTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>

  <ng-container *ngIf="phrase && phrase.showImagesSection">
    <div style="margin-left: 20px !important">
      <p-panel [header]="('translate.general.associatedImages' | translate) + ' (' + phrase.numberOfImages + ')'"
        [toggleable]="true" [collapsed]="true" [style]="{position: 'relative', top: '-1.5em'}">
        <div *ngIf="phrase.showAssociatedImagesSection" class="associatedImages">
          <ng-container *ngFor="let img of phrase.associatedImages">
            <ng-container *ngIf="img.showInTile && img.type != 'TABLE'">
              <div style="margin-bottom: 0.5em;">
                <p class="t-footnote figure-type">
                  ID: {{ img.assocImageId }}
                </p>
                <async-img [className]="'ind-img'" [url]="img.imgUrl"></async-img>
              </div>
            </ng-container>
  
          </ng-container>
        </div>
          <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>

  <div>
  <ng-container
    *ngTemplateOutlet="childTemplate;"
  ></ng-container>
</div>

<modal-popup
  *ngIf="selectedRefDoc != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="selectedRefDoc.docName"
  [isOpen]="selectedRefDoc != null"
  (onClose)="selectedRefDoc = null"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="selectedRefDoc"
      [initialPage]="1"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
    ></pdf-viewer>
  </div>
</modal-popup>